export default __webpack_public_path__ + "media/images/mailer/icon_reply-a49633f2137193cff16a055f96906a95.png";